import React from 'react';
import { useParams } from 'react-router-dom';
import UpComingProduct from './upcoming-product-file';
import PropertyGallery from 'components/artectum/item-detail/PropertyGallery';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import useFetch from 'core/hooks/api/useFetch';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';
import BlogSlider from 'components/artectum/slides/featured-projects-artectum';
import './blogDetails.css'; // Import the CSS file for placeholder styles
import { Helmet } from 'react-helmet';
const img_api = process.env.REACT_APP_IMG_API;

const injectImageAfterSecondParagraph = (htmlContent, imageSrc, imageAlt) => {
    const paragraphs = htmlContent?.split('</p>');
    if (paragraphs?.length > 2) {
        paragraphs.splice(2, 0, `<div class="text-center my-4"><img src="${imageSrc}" alt="${imageAlt}" /></div>`);
    }
    return paragraphs?.join('</p>');
};

const Placeholder = () => (
    <div className="ltn__page-details-area ltn__portfolio-details-area mb-0 mt-5">
        <Helmet>
            <title>Consejos y Tendencias en Acabados para Construcción | Artectum</title>
            <meta name="description" content="Descubre guías, tendencias y tips sobre baldosas, mosaicos y celosías de concreto. Aprende más sobre acabados para construcción." />
        </Helmet>
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section-title-area ltn__section-title-2--- text-center mb-0 d-flex flex-column gap-3 align-items-center">
                        <div className="placeholder-text" />
                        <div className="placeholder-text" />
                        <div className="placeholder-text" />
                        <div className="placeholder-text" />
                        <div className="placeholder-text short" />
                        <div className="placeholder-image-main" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="ltn__page-details-inner ltn__portfolio-details-inner ">
                        <div className="placeholder-text-show  mt-3" />
                        <div className="row  mt-3">
                            <div className="col-lg-6">
                                <div className="placeholder-image " />
                            </div>
                            <div className="col-lg-6">
                                <div className="placeholder-image" />
                            </div>
                        </div>
                        <div className="r mb-0 flex-column w-100 d-flex align-items-center mb-5 ">
                            <div className="placeholder-text  mt-3" />
                            <div className="placeholder-text short  mt-3" />
                        </div>
                        <div className="mb-5"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const PortfolioDetails = ({ productId }) => {
    const { slug } = useParams();
    const { data: product, loading } = useFetch(`${API_ENDPOINTS.BLOGS_SLUG}/${slug}`);
    let publicUrl = process.env.PUBLIC_URL + '';

    const injectedContent = injectImageAfterSecondParagraph(product?.content, (img_api + product?.src), product?.section_title);

    if (loading) return (
        <div className="loading-placeholder">
            <Placeholder />
        </div>
    );

    return (
        <div className="ltn__page-details-area ltn__portfolio-details-area mb-0 mt-5">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center mb-0">
                            <h6 className="section-subtitle ltn__secondary-color">
                                {product?.section_subtitle}
                            </h6>
                            <h1 className="section-title mb-0">{product?.section_title}</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ltn__page-details-inner ltn__portfolio-details-inner">
                            <div dangerouslySetInnerHTML={{ __html: injectedContent }} />
                            {product?.comments && (
                                <div className="row">
                                    {product?.comments.map((comment, commentIndex) => (
                                        <div className="col-lg-6" key={commentIndex}>
                                            <div className="ltn__testimonial-item ltn__testimonial-item-3">
                                                <div className="ltn__testimonial-img">
                                                    <ImageWithBaseApi src={comment.image} alt="Contenido" />
                                                </div>
                                                <div className="ltn__testimoni-info">
                                                    <div className="ltn__testimoni-info-inner">
                                                        <div className="ltn__testimoni-img">
                                                            <ImageWithBaseApi src={comment.author_image} alt="Contenido" />
                                                        </div>
                                                        <div className="ltn__testimoni-name-designation">
                                                            <h4>{comment.author_name}</h4>
                                                            <h6>{comment.author_designation}</h6>
                                                        </div>
                                                    </div>
                                                    <div className="ltn__testimoni-bg-icon">
                                                        <i className="far fa-comments" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            <div className="r mb-0 flex-column w-100 d-flex align-items-center mb-5" style={{ marginBottom: '25px !important' }}>
                                <h2 className="mb-2">{product?.section_title}</h2>
                                <PropertyGallery publicUrl={publicUrl} mediaItems={product?.media_item} title={false} />
                            </div>
                                <UpComingProduct slideSections={product?.slide_sections} />
                        </div>
                    </div>
                </div>
            </div>
                    <BlogSlider sectionClass="pt-70" />
        </div>
    );
}

export default PortfolioDetails;